// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"100":"61f8d809","723":"f11c324e"}[chunkId] + ".chunk.css";
};